import { AfterViewChecked, Component, Input } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ApprovalModalResult } from "./approval-modal-result.enum";

export interface ApprovalModalInfo {
  mainMessage: string;
  approveText: string;
  cancelText: string;
  modalHeader: string;
  hideCancelButton?: boolean;
}

@Component({
  selector: "approval-modal",
  moduleId: module.id,
  templateUrl: "approval-modal.component.html",
  styleUrls: ["./approval-modal.component.scss"],
})
//@ts-ignore
export class ApprovalModalComponent implements AfterViewChecked {
  @Input() public info: ApprovalModalInfo;

  constructor(public activeModal: NgbActiveModal) {}

  clickApprove() {
    this.activeModal.close(ApprovalModalResult.Approve);
  }

  clickCancel() {
    this.activeModal.close(ApprovalModalResult.Cancel);
  }

  ngAfterViewChecked() {}
}



// WEBPACK FOOTER //
// ./src/app/common/approval-modal/approval-modal.component.ts